import React, { createContext, useContext } from "react";

export const Ctx = createContext();

const getComponentLabels = (labels, comp) => (labels.find(l => l.name.toLowerCase() === comp.toLowerCase()) || {}).labels;

const Provider = ({ labels = [], children }) => <Ctx.Provider value={labels}>{children}</Ctx.Provider>;

export const useLocalization = (comp = "global") => {
  const labels = useContext(Ctx);

  const globalLabels = getComponentLabels(labels, "global");
  const override = comp === "global" ? globalLabels : { ...globalLabels, ...getComponentLabels(labels, comp) };

  return { ...GLOBALS.LOCALIZATION_LABELS, ...override };
};

export default Provider;
